import React, {MouseEvent, useRef} from "react";
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useAppState} from "@stores/AppStateContext";

import {openCalendarSelectRepeatOptionsCtxMenu} from "./openCalendarSelectRepeatOptionsCtxMenu";

import {CalendarSelectInput} from "./CalendarSelectInput";

import "./CalendarSelect.css";

export interface MonthDaysSelectProps {
    id: string;
    selectedDays: number[];
    onChange: (dates: number[]) => void;
    placeholder: string;
    withBackground?: boolean;
    className?: string;
}

export const MonthDaysSelect = observer((
    {
        selectedDays,
        onChange,
        placeholder,
        withBackground,
        className,
        id,
    }: MonthDaysSelectProps) => {
    const appState = useAppState();
    const mainRef = useRef<HTMLDivElement>(null);
    const ctxMenu = appState.contextMenu ;
    const isOpen = ctxMenu?.type === 'calendar-select-repeat-options';

    const openOrUpdateCtxMenu = () => {
        openCalendarSelectRepeatOptionsCtxMenu(
            appState,
            mainRef.current!,
            {
                getSelectedDates: () => selectedDays,
                onChange: onChange,
            },
            {VERTICAL_SHIFT: 4, id},
        );
    };
    const _onClick = (event: MouseEvent) => {
        event.stopPropagation();
        if (isOpen) {
            appState.setContextMenu(null);
        } else {
            openOrUpdateCtxMenu()
        }
    };

    const label = selectedDays.length
        ? selectedDays.join(', ')
        : placeholder;

    return (
        <CalendarSelectInput
            tooltipTitle={intl.get("ScheduleSetting.MonthDaysSelect").d("Select one or more days of the month when this task should repeat")}
            ref={mainRef}
            className={className}
            onClick={_onClick}
            label={label}
            withBackground={withBackground}
            isPlaceholder={label === placeholder}
            isOpen={isOpen}
        />
    );
});
